import PropTypes from 'prop-types';

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

import SearchIcon from '@mui/icons-material/Search';

const Searchbar = ({ searchQuery, setSearchQuery }) => {
  return (
    <TextField
      fullWidth
      placeholder="Search by title, reference, company, customer or status..."
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      sx={{
        backgroundColor: '#FFF',
        borderRadius: '12px',
        '& .MuiOutlinedInput-root': {
          borderRadius: '12px',
          '& fieldset': {
            borderColor: '#00A3FF',
            borderWidth: '1.5px',
          },
          '&:hover fieldset': {
            borderColor: '#00A3FF',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#00A3FF',
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: '#94A3B8' }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

Searchbar.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
};

export default Searchbar;